<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.pushStatus"
        placeholder="干部之家同步状态"
      >
        <el-option
          v-for="(item, i) in syncStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.bizType"
        placeholder="弹窗类型"
      >
        <el-option
          v-for="(item, i) in alertTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          v-model="filters.name"
          placeholder="标题"
        ></el-input>
      </el-form-item>
    <el-form-item >
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      syncStatusList: [],
      alertTypeList: [],
      onlineList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["CLASS_PUSH_STATUS", "POPUP_BIZ_TYPE", "ONLINE_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["CLASS_PUSH_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["POPUP_BIZ_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["ONLINE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.syncStatusList = res.data["CLASS_PUSH_STATUS"];
        this.alertTypeList = res.data["POPUP_BIZ_TYPE"];
        this.onlineList = res.data["ONLINE_STATUS"];
      });
    },
    resetData() {
      //重置
      this.filters = {};
      this.initData();
    },
    initData() {
      const filters = { ...this.filters }
      this.$emit("search", { ...filters, t: new Date().getTime() });
    },

  },
};
</script>
